export const WorkerConstraintTypes =
{
    "Time Interval": 0,
    "Duration": 1,
    "Not Allowed": 2,
    "Care Track": 4,
    "Not Authorized": 5
}

export const WorkerDurationConstraintType =
{
    "Hard": 1,
    "Soft": 2
}

export const WorkerConstraintMessages =
{
    "Time Interval Constraint": "You are not able to clock in at this time. If you believe this to be incorrect, please contact ",
    "Duration Constraint - Hard": "Your authorized representative has set a maximum duration of 2 hours for today and asked you not to go over this time. Exceeding this time can result in disciplinary action. If by leaving the site you endanger your client, please don’t clock out or leave the site.",
    "Duration Constraint - Soft": "Your authorized representative has asked you to work for a maximum duration of 2 hours for today. Please confirm with your authorized representative before extending your time. If by leaving the site you endanger your client, please don’t clock out or leave the site.",
    "Not allowed or not authorized": "You are not authorized to perform service on this date or day of the week. If you believe this to be an error, please contact "
}

export const RemainingMinutesMessageParts =
{
    "There is 1 hour ": "There is 1 hour ",
    "There are ": "There are ",
    " hours ": " hours ",
    "There is 1 minute ": "There is 1 minute ",
    "and 1 minute ": "and 1 minute ",
    " minutes ": " minutes ",
    "and ": "and ",
    "remaining on this POS.": "remaining on this POS."
}

export const WorkerNotificationMessages =
{
    "Shift End Time": "Your shift ends at: ",
    "Shift End - 15 minutes before": "",
    "Remaining Minutes On POS": "There are"
}

export enum Translations {
    DoYouHaveConcerns = "DoYouHaveConcerns"
}

export enum BusinessConfigurationMessages {
    AllowRecordCarePlanItems = "Mobile - Allow Record Care Plan Items",
    MobileAppCancelVisitButton = "Mobile App - Cancel Visit Button",
    NonArrivalGPSLocation = "Mobile - Non arrival GPS location > _ miles difference",
    NonDeparturelGPSLocation = "Mobile - Non departure GPS location > _ miles difference",
    ReportINROUTEStatusForVisits = "Mobile - Report IN ROUTE status for visits",
    ShowVisitTypeOnVisitsList = "Mobile - Show Visit Type On Visits List",
    StoreIntermediateCoordinates = "Mobile - Store intermediate coordinates",
    ShowEndTimeOnVisitsList = "Mobile - Show End Time On Visits List",
    CreateVisitsHideOtherOption = "Mobile - Create Visits Hide Other Option",
    EnableCaretrack = "Mobile - Enable Caretrack",
    ReportArrivalDepartureOnlyIfGPSWithinRange = "Mobile - Report arrival or departure only if GPS is within the configured range",
    ShowReseTtoNew = "Mobile Forms - Show reset to new",
    HidePatientPhones = "Mobile - Hide Patient Phones",
    EnableMedicationStorage = "Mobile Forms - Enable Medication Storage",
    RequirePatientSignatureOnWebmobile = "Mobile - Require patient signature on webmobile",
    RequireWorkerSignatureOonWebmobile = "Mobile - Require worker signature on webmobile",
    AllowChangingVisitType = "Mobile - Allow Changing Visit Type",
    ExtendedVisitDetails = "Mobile - Extended Visit Details",
    AllowChangingVisitStatus = "Mobile - Allow Changing Visit Status",
    AllWorkersCanAcceptAvailableShifts = "All workers can accept available shifts",
    MobileContiguousVisitProcessing = "Mobile Contiguous Visit Processing",
    VisitCompletionSettings = "Visit completion settings",
    ShowErrandMilesButtonOnMobileApp = "Show Errand Miles Button on Mobile App",
    ShowBreakButtonInMobileApp = "Show Break Button in Mobile App",
    ShowClockOutAIButtonInMobileApp = "Show Clock Out AI Button in Mobile App",
    ShowVisitAndPatientDocuments = "Mobile - Show visit and patient documents",
    DisplayVisitStatus = "Mobile - Display Visit Status",
    UploadDocuments = "Mobile - Upload Documents",
    AllowOnHoldVisitClosing = "Mobile - Allow on hold visit closing",
    EnableMenuFromTemplateConfigurations = "Mobile - Enable Menu From Template Configurations",
    MobileChangeTheTitleOfTheTripsPage = "Mobile - Change the title of the Trips page",
    MobileChangeTheQuestiononTheTripsPage = "Mobile - Change the question on the Trips page",
    RecordErrandMiles = "Record errand miles?",
    MobileHideNtesOnDeparture ="Mobile - Hide Notes on departure",
    SkipAuthorizationCheck = "Mobile - Skip Authorization Check",
    AllowWorkerToEnterArrivalAndDepartureTimes = "Mobile - Allow Worker To Enter Arrival And Departure Times",
    TwoFactorAuthentication = "Mobile - Two factor authentication",
    DoNotRequireCaregiverToCloseOnHoldVisitsBeforeclockIn = "DO NOT Require caregiver to close on hold visits before clock-in",
    PayableHours = "Mobile - Display Payable Hours",
    NoShowButton = "Mobile - Display No Show Button",
    IdleTimeout = "Mobile - Set idle timeout to _ minutes",
    ShowInfoOnlyCarePlanItems = "IVR - Show Info Only Care Plan Items",
    DefaultCarePlanItemsToComplete = "Default care plan items to complete",
    MoveTodayButton = "Mobile - Show Move Today Button",
    ShowAllVisitsForAssignedPatientsn = "Mobile - Show all visits for assigned clients",
    ShowCarePlanItemsInVisitHistory = "Mobile - Show Care Plan Items in Visit History",
    ReportCarePlanItemsByCode = "IVR - Report Care Plan Items By Codes",
    MobileShowProcessDocumentsButton = "Mobile - Show Process Documents Button",
    DisableTimeOverride = "IVR - Disable Time Override",
    MobileShowReportMissedVisitButton = "Mobile - Show Report Missed Visit Button",
    AllowReportExpenses = "Mobile - Report Expenses",
    MobileShowVisitUploadDocsButton = "Mobile - Show Upload visit documents button",
    ShowContiguousVisitDetails = "Mobile - Show contiguous visit details",
    ShowNotesAndInfoOnlyItems = "Mobile - Show Notes and Info Only Items",
    DisplayVisitsFromXPastDays = "Mobile Forms - Display visits for days before",
    MobileCarePlanItemHistory = "Mobile - Show care plan item history",
    MobileUptimeTolerance = "Mobile - Uptime Tolerance",
    MobileRefreshInterval = "Mobile - Refresh Uptime Interval",
    MobileVisitHistory = "Mobile - Show visit history for scheduled clients",
    MaxBillableTimeForNOSHOWVisits = 'Max billable time for NO SHOW visits',
    NumberOfDays = "Visit Reporting - Number of days you can close visits",
    ProceedIfGPSFails = "Mobile - Allow Clock in/out without GPS coordinates if getting location fails after a number of attempts",
    MobileAppButtonShowAuthInfo = "Mobile App Button - Show Auth Info",
    ShowStartVisitOnlyIfThevlientDocumentsHaveBeenReviewed = "Mobile - Start visit only if the client's documents have been reviewed",
    MobileDontAllowLoginWithoutGPSTurnedOn = "Mobile - Don't allow login without GPS turned on",
    OnlyOneCaregiverCanBeClockedIn = "Only one caregiver can be clocked in",
    ShowCarePlanTasksOnOpenShifts = "Mobile - Show care plan tasks on open shifts",
    ShowOnlyFirstNameLastInitialCityForOpenShifts = "Mobile - Show only First name, Last initial + City for open shifts",
    MobileMissedPunchAllowedForXDays = "Mobile - Missed Punch allowed for _ days",
    ShowCareTrackPayRate = "Show CareTrack PayRate",
    NotifyWorkerOfRemainingAuthorizationInTelephonyIonicMobileApp = "Notify Worker Of Remaining Authorization In Telephony/Ionic Mobile App",
    VisitTypeAllowToSkipPatientSignature = "Visit Type - Allow to Skip Patient Signature",
    VisitTypeAllowToSkipWorkerSignature = "Visit Type - Allow to Skip Worker Signature"
}

export enum ConfigurableList {
    ReasonMissedVisit = "Reason for missed visit",
    TripsDuringVisit = "Number of trips during a visit",
    WorkerRequiredDocuments = "Worker required documents",
    CancellationReason = "Cancellation Reason",
}


export enum ServiceOrderStatus {
    None = 0,
    Pending = 1,
    Booked = 2,
    Scheduled = 3,
    Rescheduled = 4,
    Arrived = 5,
    Departure = 6,
    Closed = 7,
    Canceled = 8,
    In_transit = 9,
    On_Hold = 10,
    Comitted = 11,
    Open = 12,
    Door_tag = 13,
    Unassigned = 14,
    Backorder = 15,
    Reassigned = 16,
    Assigned = 17
}

export const ServiceOrderStatusDescriptions: { [key in ServiceOrderStatus]: string } = {
    [ServiceOrderStatus.None]: "None",
    [ServiceOrderStatus.Pending]: "Pending",
    [ServiceOrderStatus.Booked]: "Booked",
    [ServiceOrderStatus.Scheduled]: "Scheduled",
    [ServiceOrderStatus.Rescheduled]: "Rescheduled",
    [ServiceOrderStatus.Arrived]: "Arrived",
    [ServiceOrderStatus.Departure]: "Departure",
    [ServiceOrderStatus.Closed]: "Closed",
    [ServiceOrderStatus.Canceled]: "Canceled",
    [ServiceOrderStatus.In_transit]: "In transit",
    [ServiceOrderStatus.On_Hold]: "On Hold",
    [ServiceOrderStatus.Comitted]: "Committed",
    [ServiceOrderStatus.Open]: "Open",
    [ServiceOrderStatus.Door_tag]: "No Show",
    [ServiceOrderStatus.Unassigned]: "Unassigned",
    [ServiceOrderStatus.Backorder]: "Backorder",
    [ServiceOrderStatus.Reassigned]: "Reassigned",
    [ServiceOrderStatus.Assigned]: "Assigned"
};

export enum ClockCategory {
    None = 0,
    ArrivalAndDeparture = 1,
    ArrivalOnly = 2,
    DepartureOnly = 3
}

export enum RequireAuthorization {
    No = 0,
    Yes = 1,
    Yes_And_Authorization_Number_Must_Be_Completed = 2
}

export enum AuthorizedServiceTimePerioud {
    PerDateRange = 0,
    Daily = 1,
    Weekly = 7,
    Monthly = 28
}

export const Invoice_PayStatus =
{
    "All": 0,
    "Not_Paid": 1,
    "Paid": 2,
    "Partial Paid": 3,
    "Denied": 4
}

export const PhoneType =
{
    "None": 0,
    "Home": 1,
    "Office": 2,
    "Fax": 3,
    "Direct": 4,
    "Mobile": 5,
    "Hospital": 6,
    "Main": 7,
    "Seasonal": 8,
    "TTY": 9,
    "Other": 10,
    "Pager": 11,
    "Phone number to call": 12
}

export const BaseTable_Value =
{
    "Not_Set": 0,
    "Patient_No_Show": 1,
    "Scheduling_Error": 2,
    "Late_Cancellation": 3
}

export const CarePlanItemType =
{
    "VitalSign": 1,
    "Task": 2,
    "Part": 3,
    "WellnessMetric": 4,
    "Custom": 5,
    "InfoOnly": 6,
    "MandatoryInformationOnly": 7,
    "PrintoutOnly": 8,
    "CustomPrintoutOnly": 9,
    "Textarea": 10
}

export enum ConnectionStatus {
    Online,
    Offline
}

export enum LogLevel {
    All = 0,
    Debug = 1,
    Info = 2,
    Error = 3,
    Off = 4
}

export enum SignatureType {
    Patient = 1,
    Worker = 6
}

export enum CalendarAdjustmentType {
    None = 0,
    Working = 1,
    Busy = 2,
    Unavailable = 3,
    UnavailableFullDay = 4,
    StandBy = 5,
    Available = 6
}

export const CalendarAdjutmentMap = new Map<CalendarAdjustmentType, string>([
    [CalendarAdjustmentType.Working, 'Available'],
    [CalendarAdjustmentType.Busy, 'Busy'],
    [CalendarAdjustmentType.Unavailable, 'Unavailable'],
    [CalendarAdjustmentType.UnavailableFullDay, 'Unavailable Full Day'],
    [CalendarAdjustmentType.StandBy, 'Stand By'],
    [CalendarAdjustmentType.Available, 'Available'],
]);


export const CalendarAdjutmentMapForAdd = new Map<CalendarAdjustmentType, string>([
    [CalendarAdjustmentType.Working, 'Available'],
    [CalendarAdjustmentType.UnavailableFullDay, 'Unavailable Full Day'],
]);

export enum ShiftResponse {
    Request = 1,
    Decline = 2,
    Accept = 3
}

export enum ClosureMethod {
    Default = 0,
    Online = 1,
    Offline = 2,
    PhoneTime = 3,
    Manual = 4
}